import React from 'react';
import { BrowserRouter as Router } from 'react-router-dom';

import Header from './components/Header';
import Navbar from './components/Navbar';
import Footer from './components/footer';
import AppRoutes from './routes/AppRoutes';
import ScrollTop from './components/ScrollTop';
import ScrollToTopButton from './components/ScrollToTopButton';

const App = () => {
  return (
    <Router>
  <Header />
  <Navbar />

  <AppRoutes />

  <ScrollTop />             {/* safe */}
  <ScrollToTopButton />     {/* portal, safe */}

  <Footer />
</Router>
  );
};

export default App;
 